import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import DatasetAdminPanelFull from '../containers/DatasetAdminPanelFull';
import DatasetAdminPanelNarrow from '../containers/DatasetAdminPanelNarrow';

const DatasetAdminPanel = ({ configuration, onChange }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: DatasetAdminPanelFull, narrow: DatasetAdminPanelNarrow }}
    onChange={onChange}
    width={800}
  />
);

export default DatasetAdminPanel;
